import { useCallback, useState } from "react";
import { submitCheckoutDraft } from "../api/client.js";
import type { CheckoutDraftDTO, CheckoutSubmitRequest } from "../api/types.js";

export interface CheckoutState {
  submitting: boolean;
  error: string | null;
  result: CheckoutDraftDTO | null;
  submit: (body: CheckoutSubmitRequest) => Promise<void>;
  reset: () => void;
}

export function useCheckout(): CheckoutState {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<CheckoutDraftDTO | null>(null);

  const submit = useCallback(async (body: CheckoutSubmitRequest) => {
    setSubmitting(true);
    setError(null);
    try {
      const data = await submitCheckoutDraft(body);
      setResult(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Checkout failed");
      throw err;
    } finally {
      setSubmitting(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setError(null);
  }, []);

  return { submitting, error, result, submit, reset };
}
